<template>
  <div id="addTemplate">
    <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left @click="backToListing" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>          
        </v-flex>
      </v-layout>
    </v-container>
    <v-form ref="formAdd">
      <v-container class="-border">
        <v-layout class="pr-4 pl-4" wrap>
          <v-flex xs12 class="button-container pr-0 text-xs-right">
            <div class="d-inline-flex" v-if="newTemplate.selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="backToListing">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-layout wrap class="mt-2">
          <v-flex class="xs12 sm6">
            <v-text-field label="Template Name" :rules="[rules.templateName]" v-model.trim="newTemplate.name" class="required pr-4 pl-4" @input="changedData"></v-text-field>
          </v-flex>
          <v-flex class="xs12 sm6">
            <v-text-field label="Demo URL" :rules="[rules.url]" v-model="newTemplate.demo_url" class="pr-4 pl-4" @input="changedData" hint="Ex: https://cdn.parentfinder.com/flipbook/19_3303/19_3303.html"></v-text-field>
          </v-flex>
          <v-layout>
            <v-flex>
              <div id="pageEditor">
                <v-container grid-list-xl fluid>
                  <v-layout row wrap>
                    <v-flex sm12>
                      <quill-editor
                        class="quill"
                        :content="newTemplate.description"
                        :options="newTemplate.editorOption"
                        v-model="newTemplate.description"
                        @input="changedData"
                      >
                      </quill-editor>
                    </v-flex>
                  </v-layout>
                </v-container>
              </div>
            </v-flex>
          </v-layout>

          <v-layout container class="pt-0">
            <v-flex xs12 sm12 v-if="templateItems">
            <span>Please save your template to upload the files</span>
            <v-card class="mt-4 pt-1 pl-2 pr-2" v-for="(item, i) of templateItems" :key="i">
              <v-layout row wrap class="custom-wrap">
                <v-flex sm11>
                  <h4 class="ml-4 pt-2 pb-2">{{item.name}}</h4>
                </v-flex>
                <v-flex sm1 class="text-xs-right" v-if="item.name !== 'Colors'">
                  <v-layout row wrap class="mr-1 pl-2">
                    <upload-btn :disabled="Object.keys(TemplateItem).length === 0" multiple icon class="template-upload-icon" @file-update="fileSelected($event, i, item.name)">
                      <template slot="icon">
                        <v-icon>add</v-icon>
                      </template>
                    </upload-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
              <div v-if="item.name === 'Pages'">
                <v-container grid-list-sm class="pa-1 pb-3">
                  <v-layout row wrap>
                     <draggable v-model="TemplateItem.page" class="layout wrap row" handle=".sortHandle" @start="drag=true" @end="drag=false;" @change="sortList" forceFallback="false">
                      <v-flex v-for="(page, n) in TemplateItem.page" :key="n" xs12 sm4 md3 class="pr-2 pl-2">
                          <v-card>  
                            <img :src="config.uploadPath + page.webPath" width="100%">
                            <v-divider horizontal></v-divider>
                            <v-flex flat class="text-xs-right pa-1 custom-bg" >
                              <v-btn icon class="ma-0 sortHandle">
                                <v-icon size="22" color="grey darken-2">open_with</v-icon>
                              </v-btn>
                              <v-btn icon class="ma-0" v-if="page._id == TemplateItem.default_page._id">
                                <v-icon size="22" color="pink lighten-3">star</v-icon>
                              </v-btn>  
                              <v-btn icon class="ma-0" v-if="page._id != TemplateItem.default_page._id" @click="makeCover(page)">  
                                <v-icon size="22" color="grey darken-2">star_border</v-icon>
                              </v-btn>
                              <v-btn icon @click="removeItem(page, 'Page')" class="ma-0">
                                <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-card>
                      </v-flex>
                    </draggable>
                  </v-layout>
                </v-container>
              </div>
              <div v-if="item.name === 'Colors'">
                <v-container grid-list-sm class="pa-1 pb-3">
                  <v-layout row wrap>
                    <v-flex xs12 sm6 class="pr-4 pl-4 pb-4">
                      <span class="pf-sub-head mb-3 custom-title">Primary color</span>
                      <v-btn block :color="templateColors.front_cover" @click="pickFrontCoverColor = !pickFrontCoverColor"></v-btn>
                      <chrome-picker :value="templateColors.front_cover" @input="changeColor($event, 'front_cover')" v-if="pickFrontCoverColor"></chrome-picker>
                    </v-flex>
                    <v-flex xs12 sm6 class="pr-4 pl-4 pb-4">
                      <span class="pf-sub-head mb-3 custom-title">Background cover color</span>
                      <v-btn block :color="templateColors.background_cover" @click="pickBackCoverColor = !pickBackCoverColor"></v-btn>
                      <chrome-picker :value="templateColors.background_cover" @input="changeColor($event, 'background_cover')" v-if="pickBackCoverColor"></chrome-picker>
                    </v-flex>
                    <v-flex xs12 sm6 class="pr-4 pl-4 pb-4">
                      <span class="pf-sub-head mb-3 custom-title">Border color</span>
                      <v-btn block :color="templateColors.border" @click="pickBorderColor = !pickBorderColor"></v-btn>
                      <chrome-picker :value="templateColors.border" @input="changeColor($event, 'border')" v-if="pickBorderColor"></chrome-picker>
                    </v-flex>
                    <v-flex xs12 sm6 class="pr-4 pl-4 pb-4">
                      <span class="pf-sub-head mb-3 custom-title">Title headings</span>
                      <v-btn block :color="templateColors.title_heading" @click="pickTitleHeadColor = !pickTitleHeadColor"></v-btn>
                      <chrome-picker :value="templateColors.title_heading" @input="changeColor($event, 'title_heading')" v-if="pickTitleHeadColor"></chrome-picker>
                    </v-flex>
                    <v-flex xs12 sm6 class="pr-4 pl-4 pb-4">
                      <span class="pf-sub-head mb-3 custom-title">Border around photos</span>
                      <v-btn block :color="templateColors.photo_border" @click="pickPhotoBorderColor = !pickPhotoBorderColor"></v-btn>
                      <chrome-picker :value="templateColors.photo_border" @input="changeColor($event, 'photo_border')" v-if="pickPhotoBorderColor"></chrome-picker>
                    </v-flex>
                    <v-flex xs12 sm6 class="pr-4 pl-4 pb-4">
                      <span class="pf-sub-head mb-3 custom-title">Inside background colors</span>
                      <v-btn block :color="templateColors.insidebackground_color" @click="pickInsideBGColor = !pickInsideBGColor"></v-btn>
                      <chrome-picker :value="templateColors.insidebackground_color" @input="changeColor($event, 'insidebackground_color')" v-if="pickInsideBGColor"></chrome-picker>
                    </v-flex>
                      <!-- <v-flex v-for="(style, n) in TemplateItem.style" :key="n" xs12 sm4 md3 class="pr-2 pl-2">
                          <v-card>  
                            <img :src="config.uploadPath + style.webPath" width="100%">
                            <v-divider horizontal></v-divider>
                            <v-flex flat class="text-xs-right pa-1 custom-bg" >
                              <v-btn icon @click="removeItem(style, 'Option')" class="ma-0">
                                <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-card>
                      </v-flex> -->
                  </v-layout>
                </v-container>
              </div>                
            </v-card>
            </v-flex>
          </v-layout>
          <v-layout wrap class="mb-3 pr-4 pl-4">
            <v-flex xs12 class="button-container pr-0 text-xs-right">
              <div class="d-inline-flex" v-if="newTemplate.selectedData">
                <v-btn class="pf-btn pf-btn-cancel" @click="backToListing">
                  <v-icon size="16" class="pr-1">cancel</v-icon>
                  <div>Cancel</div>
                </v-btn>
                <v-btn class="pf-btn pf-btn-save" @click="save">
                  <v-icon size="16" class="pr-1">check_circle</v-icon>
                  <div>Save</div>
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>
<script>
/* global session router store config */
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import UploadButton from 'vuetify-upload-button';
import draggable from 'vuedraggable';
import { create, uploadFile, update, getOne, validateUrl } from '../../helpers/helpers';
import swal from 'sweetalert2';
import Vue from 'vue';
import { Chrome } from 'vue-color';

export default {
  components: {
    'upload-btn': UploadButton,
    quillEditor,
    draggable,
    'chrome-picker': Chrome
  },
  data: () => ({
    entity: 'Template',
    currentCoverPage: null,
    deleteIndex: null,
    editIndex: null,
    currentEditor: null,
    config: config,
    newTemplate: {
      name: '',
      demo_url: '',
      description: '',
      selectedData: false,
      editor: null,
      editorOption: {
        placeholder: 'Add Template Description Here..',
      }
    },
    rules: {
      templateName: v => !!v.trim() || 'Template name is required',
      url: (v) => v === undefined || v === '' || (validateUrl(v)) || 'Please enter valid URL'      
    },
    icons: ['mdi-rewind', 'mdi-play', 'mdi-fast-forward'],
    transparent: 'rgba(255, 255, 255, 0)',
    templateItems: [
      {
        id: 1,
        name: 'Pages',
        page: [],
        style: []
      },
      {
        id: 2,
        name: 'Colors',
        page: [],
        style: []
      },
    ],
    templateColors: {
      front_cover: '#7AC142',
      background_cover: '#F195BF',
      title_heading: '#63ACDE',
      border: '#019D8C',
      photo_border: '#019D8C',
      insidebackground_color: '#828282'
    },
    pickFrontCoverColor: false,
    pickBackCoverColor: false,
    pickBorderColor: false,
    pickTitleHeadColor: false,
    pickPhotoBorderColor: false,
    pickInsideBGColor: false
  }),
  computed: {

    TemplateItem: {
      get () {
        return store.state.TemplateItem;
      },
      set (value) {
        store.commit('setTemplateItem', value);
      }
    },
    Template: {
      get () {
        return store.state.Template;
      },
      set (value) {
        store.commit('setTemplate', value);
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  }, 
  created () {
    window.getApp.$emit('pageSubHeader', 'Add');
  },
  destroyed () {
    this.templateItemsSample = '';
  },
  methods: {
    async save () {
      if (this.$refs.formAdd.validate()) {
        this.newTemplate.style = this.templateColors;
        let { error, data, status } = await create(this.entity, this.newTemplate);
        if (error) {
          console.log('error', error);
        } else {
          this.loading = false;
          this.Template.unshift(data);
          this.Template = this.Template.sort((a, b) => {
            let textA = a.name.toUpperCase();
            let textB = b.name.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
          });
          this.TemplateItem = data;
          this.currentEditor = data.id;
          this.editIndex = this.Template.indexOf(data);
          swal.fire({
            type: 'success',
            title: 'Template saved successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.newTemplate.name = this.TemplateItem.name;
              this.newTemplate.description = this.TemplateItem.description;
              this.newTemplate.selectedData = false;
              this.$router.push({ path: '/admin/templates' });
            }
          });
        }
      }
    },
    async fileSelected (files, themeIndex, type) {
      if (Object.keys(this.TemplateItem).length === 0) {
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Please save template name first.'
        };
        return false;
      }
      for (let i = 0; i < files.length; i++) {
        if (files[i] !== 'undefined') {
          this.imageName = files[i].name;
          if (this.imageName.lastIndexOf('.') <= 0) {
            return;
          }
          const fr = new FileReader();
          fr.readAsDataURL(files[i]);
          fr.addEventListener('load', async () => {
            let imagePath = fr.result;
            let id = this.TemplateItem.id;
            let postUrl = 'Template/' + id + '/' + (type === 'Colors' ? 'Style' : 'Page');
            let response = await uploadFile(postUrl, files[i], 'PUT');
            if (!response.$data) {
              console.log('error', response.$error);
              this.snackbar = {
                show: true,
                color: 'red',
                text: response.$error
              };
            } else {
              this.TemplateItem = response.$data;
              this.Template[this.editIndex] = this.TemplateItem;
            }
          });
        }
      }
    },
    addTemplate () {
      /* let rand = Math.floor(Math.random() * (this.templateItemsSample.length));
      this.templateItems.splice(0, 0, this.templateItemsSample[rand]); */
      /* this.templateItems.unshift({
        id: 2,
        name: '',
        variants: []
      }); */
    },
    changedData () {
      this.newTemplate.selectedData = true;
    },
    hideButtons () {
      this.newTemplate.selectedData = false;
    },
    changeColor (newColor, area) {
      this.templateColors[area] = newColor.hex;
      this.changedData();
    },
    removeItem (item, variant) {
      if (item._id !== this.TemplateItem.default_page._id) {
        swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            if (variant === 'Page') {
              this.deleteIndex = this.TemplateItem.page.indexOf(item);
              this.TemplateItem.page.splice(this.deleteIndex, 1);
            } else {
              this.deleteIndex = this.TemplateItem.style.indexOf(item);
              this.TemplateItem.style.splice(this.deleteIndex, 1);
            }          
            (async () => {
              let { error, data, status } = await update(this.entity, this.TemplateItem, this.TemplateItem.id);
              if (error) {
                console.log('error', error);
              } else {
                this.TemplateItem.id = this.currentEditor;
                this.Template[this.editIndex] = this.TemplateItem;
                swal.fire(
                  'Deleted!',
                  'The ' + variant + ' "' + item.name + '" has been deleted.',
                  'success'
                );
              }
            })();          
          }
        });        
      } else {
        swal.fire({
          type: 'warning',
          title: 'Cover Page',
          text: 'Please set another item as cover page to delete this!',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
      }         
    },
    backToListing () {
      this.newTemplate.selectedData = false;
      window.getApp.$emit('pageSubHeader', '');
      this.$router.push({ path: '/admin/templates' });
    },
    async sortList () {
      if (this.$refs.formAdd.validate()) {
        let { error, data, status } = await update(this.entity, this.TemplateItem, this.TemplateItem.id);
        if (error) {
          console.log('error', error);
        } else {
          this.TemplateItem.id = this.currentEditor;
          this.loading = false;
          this.Template[this.editIndex] = data;
        }
      }  
    },
    async makeCover (item) {
      this.TemplateItem.default_page = item;
      if (this.$refs.formAdd.validate()) {
        let { error, data, status } = await update(this.entity, this.TemplateItem, this.TemplateItem.id);
        if (error) {
          console.log('error', error);
        } else {
          this.TemplateItem.id = this.currentEditor;
          this.loading = false;
          this.Template[this.editIndex] = data;
          swal.fire({
            type: 'success',
            title: 'Cover page updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              // this.selectedData = false;
            }
          });          
        }
      } 
    }
  }
};
</script>
<style scoped>

  .templateSelected {
    height: 100%;
  }
  .templateSelected img {
    margin: 0 5%;
  }
  .itemRemoveBtn {
    position: absolute;
    display: inline-flex;
    left: calc(50% - 40px);
  }
  .itemRemoveBtn button {
    background-color: #fff;
  }
  .themeAddFab {
    position: relative;
  }
  .themeAddFab button {
    top: -13px;
  }
  .themesLayout {
    border: 1px solid #ccc;
    padding: 20px 0;
  }
  .templateButtonWrap {
    display: flex;
    justify-content: flex-end;
  }
  .themeButtonWrap {
    border: 1px solid #4c9e8c;
    margin: 1px 0px !important;
  }
  .template-upload-icon {
    padding: 0px;
    margin: 0 -12px 0 0;
  }
  .custom-wrap {
    padding-bottom: 12px;
    padding-top: 23px;
  }
</style>


// WEBPACK FOOTER //
// src/pages/Template/add.vue